export const ServiceIcon = ({stroke, classsName}) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={classsName}>
<g clipPath="url(#clip0_2792_46322)">
                <path d="M9.7539 11.9019C9.15435 10.8169 8.90558 9.5728 9.04181 8.34066C9.17803 7.10852 9.69256 5.94882 10.5147 5.02099C11.3367 4.09315 12.4261 3.44272 13.6328 3.15912C14.8396 2.87553 16.1046 2.97268 17.2539 3.43722L13.5039 7.50128L14.0345 9.97066L16.5039 10.5013L20.568 6.75128C21.0325 7.9006 21.1297 9.16559 20.8461 10.3724C20.5625 11.5791 19.912 12.6684 18.9842 13.4905C18.0564 14.3126 16.8967 14.8272 15.6645 14.9634C14.4324 15.0996 13.1883 14.8508 12.1033 14.2513L6.84765 20.345C6.42496 20.7677 5.85168 21.0052 5.2539 21.0052C4.65613 21.0052 4.08284 20.7677 3.66015 20.345C3.23746 19.9223 3 19.3491 3 18.7513C3 18.1535 3.23746 17.5802 3.66015 17.1575L9.7539 11.9019Z" stroke={stroke ?? "#D4002A"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</g>
<defs>
<clipPath id="clip0_2792_46322">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
    )
}